class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.content = null;
    this.formInView = true;
    this.footerInView = false;
    this.formObserver = null;
    this.footerObserver = null;
    this.onScroll = null;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    // Maison Stickers Muraux (03/11/2026) : le pied de page sur mesure (footer.msm-footer) n'a pas
    // data-ref="footer" ; sans lui, le sticky restait affiché tout en bas de la page.
    this.footer = document.querySelector('[data-ref="footer"]') || document.querySelector('footer.msm-footer');
    this.content = this.querySelector('.sticky-add-to-cart__content');

    if (!this.form || !this.content) return;

    // Réserve l'espace du sticky dans le flux pour éviter le changement de
    // hauteur du document quand le contenu passe en position: fixed. Sans cela,
    // le contenu sort du flux → la page raccourcit → le footer remonte dans le
    // viewport → le sticky se désactive → boucle infinie de clignotement.
    requestAnimationFrame(() => {
      this.style.minHeight = `${this.offsetHeight}px`;
      this.#initObservers();
    });
  }

  disconnectedCallback() {
    this.formObserver?.disconnect();
    this.footerObserver?.disconnect();
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
  }

  #initObservers() {
    this.formObserver = new IntersectionObserver(([entry]) => {
      this.formInView = entry.isIntersecting;
      this.#updateDisplay();
    });

    this.formObserver.observe(this.form);

    // Hors écran, le formulaire peut être plus bas (vrai bouton pas encore vu)
    // ou plus haut (vrai bouton dépassé) : on revérifie au défilement.
    let ticking = false;
    this.onScroll = () => {
      if (ticking || this.formInView) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        this.#updateDisplay();
      });
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });

    if (!this.footer) return;

    this.footerObserver = new IntersectionObserver(([entry]) => {
      this.footerInView = entry.isIntersecting;
      this.#updateDisplay();
    });

    this.footerObserver.observe(this.footer);
  }

  #updateDisplay() {
    // Maison Stickers Muraux (23/10/2026) : le sticky n'apparaît qu'une fois le
    // vrai bouton dépassé, jamais tant qu'il est encore plus bas dans la page.
    const formAbove = !this.formInView && this.form.getBoundingClientRect().bottom <= 0;
    const shouldBeActive = formAbove && !this.footerInView;
    const isActive = this.dataset.active === 'true';

    if (shouldBeActive === isActive) return;

    clearTimeout(this.closingTimeout);

    if (shouldBeActive) {
      delete this.dataset.closing;
      this.dataset.active = 'true';
      this.content.classList.add('color-scheme-1');
      return;
    }

    this.dataset.active = 'false';
    this.dataset.closing = 'true';

    this.closingTimeout = setTimeout(() => {
      delete this.dataset.closing;
      this.content.classList.remove('color-scheme-1');
    }, 300);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
